import styled from 'styled-components';
import { Text } from '~/components/ui/Text';

const StyledWrapper = styled.div<{ $x: number; $bottom: number }>`
	position: absolute;
	/* Позиция по X совпадает с левым краем карты (как у оффера) */
	left: calc(${(props) => props.$x}px * calc(1 / var(--zoom-factor, 1)));
	/* Над верхней кромкой карты с тем же отступом, что между картой и блоком времени */
	bottom: calc(
		${(props) => props.$bottom}px * calc(1 / var(--zoom-factor, 1)) + 20px
	);
	width: 270px;
	/* Обрезает карточку, пока та выезжает снизу */
	overflow: hidden;
	pointer-events: none;
`;

const StyledContainer = styled.div`
	position: relative;
	width: 270px;
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: flex-start;
	gap: 10px;
	padding: 20px;
	background-color: rgba(17, 19, 20, 0.95);
	border: 1px solid rgba(255, 255, 255, 0.1);
	border-radius: 10px;
	pointer-events: auto;

	transition: transform 0.3s;
	transform: translateY(100%);

	&.hint-enter {
		transform: translateY(100%);
	}

	&.hint-enter-active,
	&.hint-enter-done,
	&.hint-exit {
		transform: translateY(0);
	}

	&.hint-exit-active {
		transform: translateY(100%);
	}
`;

const StyledHeader = styled.div`
	display: flex;
	align-items: center;
	gap: 10px;
	/* Место под таймер справа, чтобы заголовок не заезжал под него */
	padding-right: 26px;
`;

const StyledTitle = styled(Text)`
	font-size: 16px;
	font-weight: 500;
	color: #ffffff;
`;

const StyledDescription = styled(Text)`
	width: 230px;
	font-size: 14px;
	font-weight: 400;
	color: #ffffff;
	opacity: 0.5;
`;

const StyledTimerNumber = styled.div`
	position: absolute;
	right: 18px;
	top: 18px;
	width: 20px;
	height: 20px;
	background-color: #ffffff;
	border-radius: 50%;
	display: flex;
	align-items: center;
	justify-content: center;

	${Text} {
		font-weight: 700;
		font-size: 12px;
		color: #000000;
	}
`;

export {
	StyledContainer,
	StyledDescription,
	StyledHeader,
	StyledTimerNumber,
	StyledTitle,
	StyledWrapper,
};
